export const ADD_MEDIA = 'ADD_MEDIA'

export const LOAD_MEDIA = 'LOAD_MEDIA'

export const LOAD_PAGES = 'LOAD_PAGES'

export const LOAD_SOCIAL_MEDIA = 'LOAD_SOCIAL_MEDIA'



